var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCircleDownarrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z",
    fill: "#F0F0F0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_21_585)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.2499 12.5002L19.2499 25.6897L15.2802 21.7199C15.211 21.6483 15.1282 21.5911 15.0367 21.5518C14.9452 21.5125 14.8468 21.4918 14.7472 21.491C14.6477 21.4901 14.5489 21.5091 14.4567 21.5468C14.3646 21.5845 14.2808 21.6402 14.2104 21.7106C14.14 21.781 14.0843 21.8648 14.0466 21.9569C14.0089 22.0491 13.9899 22.1479 13.9908 22.2475C13.9916 22.347 14.0123 22.4455 14.0516 22.537C14.0909 22.6285 14.1481 22.7112 14.2197 22.7804L19.4697 28.0304C19.6103 28.171 19.8011 28.25 19.9999 28.25C20.1988 28.25 20.3895 28.171 20.5302 28.0304L25.7802 22.7804C25.9168 22.639 25.9924 22.4495 25.9907 22.2529C25.989 22.0562 25.9101 21.8681 25.7711 21.729C25.632 21.59 25.4439 21.5111 25.2472 21.5094C25.0506 21.5077 24.8611 21.5833 24.7197 21.7199L20.7499 25.6897L20.7499 12.5002C20.7499 12.3012 20.6709 12.1105 20.5303 11.9698C20.3896 11.8292 20.1989 11.7502 19.9999 11.7502C19.801 11.7502 19.6103 11.8292 19.4696 11.9698C19.329 12.1105 19.2499 12.3012 19.2499 12.5002Z",
    fill: "#141414"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_21_585"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(11 29) rotate(-90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleDownarrow);
export default __webpack_public_path__ + "static/media/circleDownarrow.4265ab2f1b6bcf6f285202cea6985c58.svg";
export { ForwardRef as ReactComponent };